import { useWebNativeAppPromo } from '../../hooks/useWebNativeAppPromo';

export function WebNativeAppPromoHost(): null {
  useWebNativeAppPromo();
  return null;
}
